import { takeEvery, call, select, put } from 'typed-redux-saga'
import { errorHandler, notifyMessageCreator } from 'Modules'
import { Deserialize } from 'cerialize'
import {
	CompanyModel,
	partnerAddressesApi,
	getPartnerIdSelector,
	PartnerAddressesNS,
	partnerAddressesSlice,
	companySlice,
	companySelectors,
} from 'Pages/company'
import { RequestParams } from 'Models'

export function* getPartnerAddresses(action: PartnerAddressesNS.GetPartnerAddresses) {
	try {
		let { partner_id } = action.payload
		if (!partner_id) partner_id = yield* select(getPartnerIdSelector)
		const { callback } = action.payload
		const res = yield* call(partnerAddressesApi.getPartnerAddresses, partner_id)
		const addresses = res.map((address): CompanyModel => Deserialize(address, CompanyModel))
		callback?.(addresses)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* createPartnerAddresses(action: PartnerAddressesNS.CreatePartnerAddresses) {
	try {
		const { data, callback } = action.payload
		let partner_id = data?.partner_id ?? null

		if (!partner_id) partner_id = yield* select(getPartnerIdSelector)
		const res = yield* call(partnerAddressesApi.createPartnerAddresses, partner_id, {
			...data,
			partner_id,
		})
		yield* put(companySlice.actions.getAll({ params: new RequestParams(), clear: true }))
		callback?.(res)
	} catch (error) {
		const { errorCallback } = action.payload
		yield* call(errorHandler, error)
		errorCallback?.()
	}
}

export function* updatePartnerAddresses(action: PartnerAddressesNS.UpdatePartnerAddresses) {
	try {
		const { data } = action.payload
		let partner_id = data?.partner_id ?? null
		if (!partner_id) partner_id = yield* select(getPartnerIdSelector)
		const currentRequestParams = yield* select(companySelectors.selectCurrentParams)
		const { query, params } = currentRequestParams
		const { callback } = action.payload
		const res = yield* call(
			partnerAddressesApi.updatePartnerAddresses,
			partner_id,
			data.id,
			Object.assign(new CompanyModel(), {
				...data,
				partner_id,
			})
		)
		yield* put(
			companySlice.actions.getAll({
				params: new RequestParams(null, null, query, params),
				clear: true,
			})
		)
		callback?.(res)
	} catch (error) {
		const { errorCallback } = action.payload
		yield* call(errorHandler, error)
		errorCallback?.()
	}
}

export function* deletePartnerAddresses(action: PartnerAddressesNS.DeletePartnerAddresses) {
	try {
		const { id } = action.payload
		let { partner_id } = action.payload
		if (!partner_id) partner_id = yield* select(getPartnerIdSelector)
		const { callback } = action.payload
		yield* call(partnerAddressesApi.deletePartnerAddresses, partner_id, id)
		yield* call(notifyMessageCreator, 'common.adress_delete.success')
		yield* put(companySlice.actions.getAll({ params: new RequestParams(), clear: true }))
		callback?.()
	} catch (error) {
		const { errorCallback } = action.payload
		yield* call(errorHandler, error)
		errorCallback?.()
	}
}

export const partnerAddressesSaga = function* saga() {
	yield* takeEvery(partnerAddressesSlice.actions.getPartnerAddresses, getPartnerAddresses)
	yield* takeEvery(partnerAddressesSlice.actions.createPartnerAddresses, createPartnerAddresses)
	yield* takeEvery(partnerAddressesSlice.actions.updatePartnerAddresses, updatePartnerAddresses)
	yield* takeEvery(partnerAddressesSlice.actions.deletePartnerAddresses, deletePartnerAddresses)
}
